import { IcoEdit } from 'icone';
import React, { useState } from 'react';
import { Button, Modal, OverlayTrigger, Tab, Tabs, Tooltip } from 'react-bootstrap';
import { ContinuosReportingType } from '../ContinuosReporting';
import DataHeader from 'components/DataHeader';
import ContinuosReportingDeliverablesAndMilestones from './ContinuosReportingDeliverablesAndMilestones';
import ContinuosReportingValidateModal from './ContinuosReportingValidateModal';
import ContinuosReportingStatus from './ContinuosReportingStatus';
import CheckDocTab from 'components/projectStatements/CheckDocTab';
import ContinuosReportingSummary from './ContinuosReportingSummary';

interface ContinuosReportingUpdateModalProps {
	data: ContinuosReportingType;
	fetchData: () => void;
	isCoordinator: boolean;
	isEnabledToView: boolean;
	state: 'DRAFT' | 'VALIDATED';
	isBeneficiary: boolean;
	isProjectWp: boolean;
}

const ContinuosReportingUpdateModal: React.FC<ContinuosReportingUpdateModalProps> = ({
	data,
	fetchData,
	isCoordinator,
	isEnabledToView,
	state,
	isBeneficiary,
	isProjectWp,
}) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [activeKey, setActiveKey] = useState(state === 'VALIDATED' ? 'status' : 'output');

	const [inputValues, setInputValues] = useState({
		contextAndObjectives: data.contextAndObjectives || '',
		expectedOutcomes: data.expectedOutcomes || '',
		workPerformedAndResults: data.workPerformedAndResults || '',
		projectPolicyRelevance: data.projectPolicyRelevance || '',
	});

	const headerElements = [
		{
			name: <span className="text-nowrap">ID</span>,
			value: data.continuosReportingNumber,
		},
	];
	const tabs = [
		...(state === 'VALIDATED'
			? [
					{
						eventKey: 'status',
						title: 'Status',
						content: <ContinuosReportingStatus data={data} isBeneficiary={isBeneficiary} isEnabledToView={isEnabledToView} />,
					},
				]
			: []),
		...(state === 'VALIDATED'
			? [
					{
						eventKey: 'integration',
						title: 'Integrazione',
						content: (
							<CheckDocTab
								detail={data}
								tab={activeKey}
								conditionalitiesFilterCodes={['Integrazione']}
								isValidated={state === 'VALIDATED'}
								handleChanges={() => {}}
								setDetail={() => {}}
								isProjectWp={isProjectWp}
								isBeneficiary={isBeneficiary}
								isCoordinator={isCoordinator}
								isEnabledToView={isEnabledToView}
							/>
						),
					},
				]
			: []),
		{
			eventKey: 'output',
			title: 'Output',
			content: (
				<ContinuosReportingDeliverablesAndMilestones
					data={data}
					isCoordinator={isCoordinator}
					isEnabledToView={isEnabledToView}
					state={state}
				/>
			),
		},
		// ...(isCoordinator || isEnabledToView
		// 	? [
		{
			eventKey: 'summary',
			title: 'Summary',
			content: (
				<ContinuosReportingSummary
					data={data}
					state={state}
					activeKey={activeKey}
					inputValues={inputValues}
					setInputValues={setInputValues}
					isCoordinator={isCoordinator}
					isEnabledToView={isEnabledToView}
				/>
			),
		},
		// 	]
		// : []),
	];
	return (
		<>
			<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>Modifica</Tooltip>}>
				<span>
					<Button
						variant="link"
						onClick={() => {
							setIsModalOpen(true);
						}}
					>
						<IcoEdit className="second-color ico-small edit" />
					</Button>
				</span>
			</OverlayTrigger>
			<Modal
				size="lg"
				show={isModalOpen}
				onHide={() => {
					setIsModalOpen(false);
					setActiveKey(state === 'VALIDATED' ? 'status' : 'output');
					fetchData();
				}}
				fullscreen
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>
						<DataHeader
							data={headerElements}
							customStyle={{
								margin: 0,
								paddingTop: '5px',
								paddingBottom: 0,
								marginLeft: '15px',
							}}
						/>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{/* {state === 'DRAFT' ? (
						<ContinuosReportingDeliverablesAndMilestones data={data} isCoordinator={isCoordinator} isEnabledToView={isEnabledToView} state={state} />
					) : null}
					{state === 'VALIDATED' ? ( */}
					<Tabs className="mb-4" variant="pills" activeKey={activeKey} onSelect={(key) => setActiveKey(key)} fill>
						{tabs.map((tab) => (
							<Tab key={tab.eventKey} eventKey={tab.eventKey} title={tab.title}>
								{activeKey === tab.eventKey ? tab.content : null}
							</Tab>
						))}
					</Tabs>
					{/* ) : null} */}
				</Modal.Body>
				{state === 'DRAFT' ? (
					<Modal.Footer className="d-flex justify-content-center">
						{isCoordinator || isEnabledToView ? <ContinuosReportingValidateModal data={data} fetchData={fetchData} /> : null}
					</Modal.Footer>
				) : null}
			</Modal>
		</>
	);
};

export default ContinuosReportingUpdateModal;
